import { Button } from '@mantine/core';
import './WFIDButton.css';

interface IWFIDButton {
  color?: string;
  variant?: 'outline' | 'filled';
  onClick: () => void;
  width?: string | number;
  content: any;
  disabled?: boolean;
  bgColor?: string;
}

const WFIDButton = (props: IWFIDButton) => {
  const {
    color = '#151515',
    variant = 'outline',
    onClick,
    width = undefined,
    content,
    disabled = false,
    bgColor = undefined,
  } = props;

  return (
    <Button
      w={width}
      className='wfid-button'
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled}
      size='sm'
      bg={bgColor}
    >
      {content}
    </Button>
  );
};

export default WFIDButton;
